import useApprovalCountStore from '@features/approval/model/useApprovalCountStore';
import NotificationDot from '@shared/assets/images/notification-dot.svg';

import styles from '@shared/components/atoms/ApprovalNotificationDot/ApprovalNotificationDot.module.scss';
/**
 * 미결 문서 존재 시 표시되는 결재 알림 Dot
 */
export default function ApprovalNotificationDot() {
  const { approvalIngCount } = useApprovalCountStore();

  const hasApprovalIng = approvalIngCount !== null && approvalIngCount > 0;

  if (!hasApprovalIng) {
    return null;
  }

  return (
    <span className={styles.existBadge}>
      <img src={NotificationDot} alt="미결 문서 알림" />
    </span>
  );
}
